(ns ductile.ui.scope
  (:require
   [nextjournal.clerk.render.localstorage :as localstorage]
   [reagent.core :as r]))

(defonce !scopes-debug-mode? (r/atom (localstorage/get-item "scopes-debug-mode")))

(defn scopes-debug-mode? []
  @!scopes-debug-mode?)

(defn toggle-scopes-debug-mode! []
  (swap! !scopes-debug-mode? not)
  (localstorage/set-item! "scopes-debug-mode" @!scopes-debug-mode?))

(defn required-scope-debug-ui-display [required-scopes content]
  [:div.border-red-800.border-2.p-1
   [:pre (pr-str required-scopes)]
   content])

(defn required-scope-debug-ui-wrapper [required-scopes content]
  (if (and (scopes-debug-mode?)
           (not-empty required-scopes))
    (required-scope-debug-ui-display required-scopes content)
    content))

